export const getLanguageFromCountry = (countryCode) => {
    if (!countryCode) return null;
    const code = countryCode.toUpperCase();

    if (code === 'JP') return 'ja';
  
    // Spanish Speaking Countries
    const esCountries = [
      'AR', // Argentina
      'BO', // Bolivia
      'CL', // Chile
      'CO', // Colombia
      'CR', // Costa Rica
      'CU', // Cuba
      'DO', // Dominican Republic
      'EC', // Ecuador
      'ES', // Spain
      'GQ', // Equatorial Guinea
      'GT', // Guatemala
      'HN', // Honduras
      'MX', // Mexico
      'NI', // Nicaragua
      'PA', // Panama
      'PE', // Peru
      'PR', // Puerto Rico
      'PY', // Paraguay
      'SV', // El Salvador
      'UY', // Uruguay
      'VE'  // Venezuela
    ];
  
    // Arabic Speaking Countries
    const arCountries = [
      'AE', // United Arab Emirates
      'BH', // Bahrain
      'DJ', // Djibouti
      'DZ', // Algeria
      'EG', // Egypt
      'EH', // Western Sahara
      'ER', // Eritrea
      'IQ', // Iraq
      'JO', // Jordan
      'KM', // Comoros
      'KW', // Kuwait
      'LB', // Lebanon
      'LY', // Libya
      'MA', // Morocco
      'MR', // Mauritania
      'OM', // Oman
      'PS', // Palestine
      'QA', // Qatar
      'SA', // Saudi Arabia
      'SD', // Sudan
      'SO', // Somalia
      'SS', // South Sudan
      'SY', // Syria
      'TD', // Chad
      'TN', // Tunisia
      'YE'  // Yemen
    ];
  
    // Chinese Speaking Regions
    const zhCountries = [
      'CN', // China
      'HK', // Hong Kong
      'MO', // Macau
      'TW'  // Taiwan
    ];
  
    // Hindi (India)
    // Note: English is also widely used in India, but if 'hi' is supported, likely intended for IN.
    const hiCountries = [
      'IN'
    ];
  
    if (esCountries.includes(code)) return 'es';
    if (arCountries.includes(code)) return 'ar';
    if (zhCountries.includes(code)) return 'zh';
    if (hiCountries.includes(code)) return 'hi';
  
    return 'en';
  };
  